import { render, staticRenderFns } from "./cropper-demo.vue?vue&type=template&id=579cbc54&scoped=true"
import script from "./cropper-demo.vue?vue&type=script&lang=js"
export * from "./cropper-demo.vue?vue&type=script&lang=js"
import style0 from "./cropper-demo.vue?vue&type=style&index=0&id=579cbc54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579cbc54",
  null
  
)

export default component.exports